import { useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";
import { toast } from "react-toastify";

export const useCollectors = (token, shouldFetch = false) => {
    const fetchCollectors = async () => {
        if (!token) {
            throw new Error("Missing required parameters");
        }
        const response = await axios.get(`${Config.ApiUrl}/tenant/payment/collectors`, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response;
    };

    const {
        data,
        isLoading,
        error,
        refetch,
        isFetching
    } = useQuery(
        ["collectors"],
        fetchCollectors,
        {
            enabled: shouldFetch && !!token,
            onSuccess: (response) => {
                if (response?.data?.data?.length === 0) {
                    toast.info("No collectors available for offline payment");
                }
            },
            onError: (error) => {
                const errorMessage = error?.response?.data?.msg || error?.message || "Failed to fetch collectors";
                toast.error(errorMessage);
            },

        }
    );

    return {
        collectors: data?.data?.data || [],
        collectorsResponse: data?.data,
        isLoadingCollectors: isLoading || (shouldFetch && isFetching),
        collectorsError: error,
        refetchCollectors: refetch,
    };
};